import { Box, Button, FileInput, Input, LoadingOverlay, Paper, Select, SimpleGrid, Space, Text, TextInput, Title } from '@mantine/core'
import React, { memo, useEffect, useState } from 'react'
import useFetch from '../../../../Customhooks/useFetch';
import { useNavigate, useParams } from 'react-router-dom';
import { baseUrl } from '../../../../Constants/constant';
import { notifications } from '@mantine/notifications';
import classes from '../ManageRawmaterial.module.css'


const Addrawmaterial = () => {
    const navigate = useNavigate();
    const [materialname, setMaterialname] = useState<string>('');
    const [verticals, setVerticals] = useState<any>();
    const [selectedVertical, setSelectedVertical] = useState<any>();
    // const [cotwo, setCoTwo] = useState<string>('');
    const [errors, setErrors] = useState<Record<string, string>>({});
    const token = localStorage.getItem("token")
    const { id } = useParams();
    const method = id ? 'PUT' : 'POST'
    const url = id ? `${baseUrl}admin/raw-materials/update/${id}` : `${baseUrl}admin/raw-materials/add`
    const {
        data: getData,
        loading: detailLoading,
        error: getError,
        fetchData: postmaterial,
    } = useFetch({
        method: method,
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "token": token
        },
        body: JSON.stringify({
            material_name: materialname,
            vertical_id: selectedVertical,
            // co2_embedded: cotwo,
        }),
    });
    const { data: getverticalData, fetchData: getVerticals } = useFetch({
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            token: token,
        },
    });
    const {
        data: getfieldData,
        loading: getfieldLoading,
        error: getfielderror,
        fetchData: getfield,
    } = useFetch({
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "token": token
        },
    });
    useEffect(() => {
        getVerticals(`${baseUrl}admin/verticals`);
        if (id) {
            getfield(`${baseUrl}admin/raw-materials/${id}`)
        }
    }, [])
    useEffect(() => {
        if (getfieldData?.data?.rows?.length && verticals?.length) {
            setMaterialname(getfieldData?.data?.rows[0]?.material_name);
            // setCoTwo(getfieldData.data.rows[0].co2_embedded);
            const matchingVertical = verticals.find((v: any) => v.label === getfieldData?.data?.rows[0]?.Vertical?.vertical_name);

            setSelectedVertical(matchingVertical?.value || null);
        }
    }, [getfieldData, verticals]);
    useEffect(() => {
        if (getverticalData?.data?.rows) {
            setVerticals(
                getverticalData?.data?.rows?.map((el: any) => ({
                    value: el?.vertical_id.toString(),
                    label: el?.vertical_name,
                }))
            );
        }
    }, [getverticalData]);
    // **Reusable function to handle input change and remove errors**
    const handleChange = (field: string, value: string | null) => {
        if (field === "material_name") {
            setMaterialname(value as string);

        } else if (field === "vertical_id") {
            setSelectedVertical(value);
        }
        // else if (field === "co2_id") {
        //     setCoTwo(value as string);
        // }

        // Remove the error for the field if it's being updated
        setErrors((prev: any) => ({ ...prev, [field]: undefined }));
    };

    // **Validate inputs before submitting**
    const validateFields = () => {
        let newErrors: Record<string, string> = {};

        if (!materialname.trim()) {
            newErrors.material_name = "Raw Material Name is Required";
        }
        if (!selectedVertical) {
            newErrors.vertical_id = "Vertical Name is Required";
        }
        // if (!cotwo) {
        //     newErrors.co2_id = "CO₂ is Required";
        // }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return false; // Validation failed
        }
        return true; // Validation passed
    };

    const handlesave = async () => {
        if (!validateFields()) return; // Stop if validation fails
        await postmaterial(url);
    };
    useEffect(() => {
        const showNotification = (type: any, title = "An error occurred") => {
            notifications.show({
                title,
                message: type === 'success'
                    ? "Transport data saved successfully."
                    : "Something went wrong. Please try again.",
                color: type === 'success' ? "green" : "red",
                classNames: classes,
            });
        };

        if (getData?.errors || getError) {
            showNotification('error', getData?.message || getError?.message);
            return;
        }

        if (getData && !getData?.errors) {
            navigate('/manage-raw-material');
        }
    }, [getData, getError, navigate, classes]);


    // const handlesave = async () => {
    //     await postmaterial(url);
    //     navigate('/manage-raw-material');
    // };
    return (
        <>
            <LoadingOverlay
                visible={getfieldLoading}
                zIndex={1000}
                overlayProps={{
                    radius: 'sm',
                    blur: 2,
                    style: {
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%'
                    }
                }}
                loaderProps={{ color: '#404040', type: 'bars' }}
            />
            <Paper shadow="xs" p="xs" radius="md">
                <Box ml={5}>
                    <Title order={4}>Add Raw Material</Title>
                    <Space h="lg" />
                    <Text>Raw Material Details</Text>
                    <Space h="xs" />
                    <SimpleGrid cols={4}>
                        <Select
                            label="Select Category"
                            withAsterisk
                            variant='filled'
                            placeholder='Select Category'
                            data={verticals}
                            searchable
                            maxDropdownHeight={200}
                            value={selectedVertical}
                            onChange={(value) => handleChange("vertical_id", value)}
                            radius={6}
                            error={errors.vertical_id}
                        />
                        <TextInput
                            variant='filled'
                            label="Raw Material name"
                            withAsterisk
                            value={materialname}
                            onChange={(e) => handleChange("material_name", e.target.value)}
                            placeholder="Raw Material name"
                            radius={6}
                            error={errors.material_name}
                        />

                        {/* <TextInput
                        variant='filled'
                        withAsterisk
                        label="CO₂ Embodied"
                        value={cotwo}
                        onChange={(e) => handleChange("co2_id", e.target.value)}
                        placeholder="Enter Embodied"
                        radius={6}
                        error={errors.co2_id}
                        /> */}

                    </SimpleGrid>
                    <Space h="xl" />
                    <SimpleGrid cols={6}>
                        <Button
                            variant="default"
                            radius={6}
                            onClick={() => navigate('/manage-raw-material')}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="gradient"
                            gradient={{ from: '#404040', to: '#404040', deg: 90 }}
                            radius={6}
                            onClick={handlesave}
                        >
                            {id ? 'Update' : 'Save'}
                        </Button></SimpleGrid>
                </Box>
            </Paper>
        </>
    )
}

export default memo(Addrawmaterial)